<div class="page_wrapper">
  <app-header-new></app-header-new>
  <div class="container-fluid wrapper-page header-fix position-relative display-contents">
    <div class="container mt-5">
      <div class="row justify-content-center ">
        <div class="col-md-5">
          <img src="/assets/images/forgot-pass.png" class="w-100" />
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-5 mt-4 mt-md-0">
          <p class="text-color font-size-30 font-weight-500">RESET PASSWORD</p>
          <p class="text-change font-size-15 font-weight-500">Enter your new password for your account.</p>
          <form #userForm="ngForm">
            <!-- <div class="form-group mt-4 inputWithIcon position-relative">
              <input type="text" class="form-control" name="usereid" [(ngModel)]='user.email_id' type="text"
                #usereid="ngModel" readonly required>
            </div> -->
            <div class="form-group mt-4 inputWithIcon position-relative">
              <input [type]="isMutePass?'text':'password'" class="form-control" placeholder="New Password"
                [(ngModel)]=user.password0 name="password0" #password0="ngModel" required [pattern]="passwordRegex">
              <i class="fa text-color-font fa-lg position-absolute cursor"
                [ngClass]="{'fa-eye': isMutePass, 'fa-eye-slash': ! isMutePass }"
                (click)="isMutePass = !isMutePass"></i>
            </div>
            <div class="alert alert-danger" *ngIf="password0.touched && password0.errors?.required">
              *Password is required.
            </div>
            <div class="alert alert-danger" *ngIf="password0.touched && password0.errors?.pattern">
              *Password should be atleast 8 characters, should contain one uppercase letter, one lowercase letter,
              one special character(from <b> !@#$%^&()* </b>) and one number.
            </div>

            <div class="form-group mt-4 inputWithIcon position-relative">
              <input [type]="isMuteCfmPass?'text':'password'" placeholder="Confirm New Password" class="form-control"
                required [(ngModel)]=user.password #password="ngModel" name="password">
              <i class="fa text-color-font fa-lg position-absolute cursor"
                [ngClass]="{'fa-eye': isMuteCfmPass, 'fa-eye-slash': !isMuteCfmPass }"
                (click)="isMuteCfmPass = !isMuteCfmPass"></i>
            </div>

            <div class="alert alert-danger" *ngIf="password.touched && password.errors?.required">
              * Confirm Password required
            </div>
            <div class="alert alert-danger"
              *ngIf="password.touched && user.password.length > 0 && userForm.value.password !== userForm.value.password0">
              * Password mismatch
            </div>

            <button type="button" class="btn btn-primary w-100 mt-4"
              [disabled]="!(userForm.valid) || userForm.value.password !== userForm.value.password0"
              (click)="resetUserPass()">CHANGE MY PASSWORD</button>
          </form>
        </div>
      </div>
    </div>
  </div>
  <app-footer-new></app-footer-new>
</div>